const fetchWorkspaces = async () => {

    const response = await fetch('/api/workspaces/list', { method: "GET" });
    const responseJson = await response.json();
    return responseJson;

}

export const workspacesService = { fetchWorkspaces }